import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";
import AvFieldSelect from "components/Common/AvFieldSelect";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useModal from "hooks/useModal";
import { exportClients } from "apis/client";

function ClientExport({ filteredValues = {}, searchInputText = "" }) {
  const [show, toggle] = useModal();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const fileTypes = ["csv", "xlsx"];

  const buildPayload = (fileType) => {
    const payload = {
      fileType,
      filteredValues,
    };
    if (searchInputText !== "" && searchInputText.length >= 3) {
      payload.searchText = searchInputText.split("@").shift();
    }
    return payload;
  };

  const handleDownload = (fileType) => {
    const today = new Date();
    const fileName = `Clients ${today.toLocaleDateString("en-GB").replace(/\//g, "-")}.${fileType}`;
    setLoading(true);
    exportClients(buildPayload(fileType)).then((blob) => {
      if (!blob || !(blob instanceof Blob)) {
        setLoading(false);
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);
      toggle();
    }).catch(() => {
      setLoading(false);
    });
  };

  return (
    <React.Fragment>
      <div>
        <Button color="primary" size="md" onClick={toggle}>
          <i className="bx bx-export me-1" />
          {t("Export")}
        </Button>
      </div>
      <Modal isOpen={show} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>
          {t("Export Clients")}
        </ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={(e, v) => handleDownload(v.fileType)}>
            <AvFieldSelect
              name="fileType"
              label={t("File Type")}
              options={fileTypes.map((type) => ({
                value: type,
                label: type.toUpperCase()
              }))}
              required
            />
            <ModalFooter className="d-flex justify-content-center pb-0">
              <Button type="submit" color="primary" disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : t("Download")}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

export default withTranslation()(ClientExport);
